import * as THREE from "three";

export default class TetgenGeometry extends THREE.BufferGeometry {
  constructor(vertices: number[], tetrahedra: number[]) {
    super();

    const index = [];
    const done = new Set();
    const addFace = (a, b, c) => {
      const s = a + b + c;
      [a, c] = [Math.min(a, b, c), Math.max(a, b, c)];
      b = s - a - c;
      const key = `${a},${b},${c}`;
      if (!done.has(key)) {
        done.add(key);
        index.push(a, b, c);
      }
    };
    for (let i = 0; i < tetrahedra.length; i += 4) {
      addFace(tetrahedra[i+0], tetrahedra[i+1], tetrahedra[i+2]);
      addFace(tetrahedra[i+1], tetrahedra[i+2], tetrahedra[i+3]);
      addFace(tetrahedra[i+2], tetrahedra[i+3], tetrahedra[i+0]);
      addFace(tetrahedra[i+3], tetrahedra[i+0], tetrahedra[i+1]);
    }
    this.setIndex(index);

    this.setAttribute(
      "position",
      new THREE.Float32BufferAttribute(vertices, 3)
    );
    this.setAttribute(
      "normal",
      new THREE.Float32BufferAttribute(vertices.length, 3)
    );
    this.computeVertexNormals();
  }
}
